import data from "../../../../../src/LabelGroup/LabelGroup.docs.json";
import * as React from 'react';
export default {
  data,
  React
};